<template>
  <div v-loading="loading">
    <div class="box-card">
      <div class="text item">
        <network-info :network-info="networkInfo"></network-info>
        <div class="setting">{{ $t("lang.wire.functionConfiguration") }}</div>
        <!-- 协议为dhcp时显示 -->
        <div class="box-card" v-if="data.proto === 'dhcp'">
          <div class="text">
            <div class="Table-Con">
              <el-form ref="ruleForm" label-width="300px" class="demo-ruleForm">
                <el-form-item :label="`${$t('lang.ConfigSetting.Protocol')}：`" prop="name">
                  <el-select :placeholder="$t('lang.ConfigSetting.pleaseChoose')" v-model="data.proto" size="mini"
                    class="Form-Input-Width">
                    <el-option v-for="item in protocol" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="`${$t('lang.ConfigSetting.DHCP')}：`" prop="name">
                  <el-input size="mini" class="Form-Input-Width" v-model="data.hostname"
                    @change="ErrorHost(data.hostname, 'hostname')">
                  </el-input>
                  <p class="error-mess" v-if="error.hostname">
                    {{ $t("lang.ConfigSetting.Pleasecheck") }}
                  </p>
                </el-form-item>
                <!-- <el-form-item label="PIN：" prop="name">
                  <el-input size="mini" class="Form-Input-Width" v-model="data.pincode"></el-input>
                </el-form-item> -->
                <el-form-item :label="`${$t('lang.ConfigSetting.NetworkType')}：`" prop="name">
                  <el-select :placeholder="$t('lang.ConfigSetting.pleaseChoose')" v-model="data.nettype" size="mini"
                    class="Form-Input-Width">
                    <el-option v-for="item in InternetList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIMmode')">
                  <el-select v-model="data.sim_mode" size="mini" class="Form-Input-Width">
                    <el-option label="SIM1" :value="'1'"></el-option>
                    <el-option label="SIM2" v-if="data.sim_mode == 0 || data.sim_mode == 2" :value="'2'"></el-option>
                    <el-option :label="$t('lang.ConfigSetting.Dualcardbackup')"
                      v-if="data.sim_mode == 0 || data.sim_mode == 2" :value="'0'"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIMDefaultConfig')">
                  <el-select v-model="data.defcfg" size="mini" class="Form-Input-Width">
                    <el-option :label="$t('lang.openvpn.open')" :value="'1'"></el-option>
                    <el-option :label="$t('lang.openvpn.close')" :value="'0'"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM1APNaccesspoint')" v-if="data.sim_mode == 1 ||
                  data.sim_mode == 0 || data.sim_mode == ''
                  ">
                  <select-input :SelectArr="apnList" :SelectValue="data.sim1_apn" @GetSelectValue="GetSelectValueSim1Apn">
                  </select-input>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM1username')"
                  v-if="data.sim_mode == 1 || data.sim_mode == 0">
                  <select-input :SelectArr="SetSeleValueList" :SelectValue="data.sim1_user"
                    @GetSelectValue="GetSelectValueSim1User">
                  </select-input>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM1password')"
                  v-if="data.sim_mode == 1 || data.sim_mode == 0">
                  <select-input :SelectArr="SetSeleValueList" :SelectValue="data.sim1_pwd"
                    @GetSelectValue="GetSelectValueSim1Pwd">
                  </select-input>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM1authenticationtype')"
                  v-if="data.sim_mode == 1 || data.sim_mode == 0">
                  <el-select v-model="data.sim1_authtype" size="mini" class="Form-Input-Width">
                    <el-option label="NONE" :value="'0'"></el-option>
                    <el-option label="PAP" :value="'1'"></el-option>
                    <el-option label="CHAP" :value="'2'"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM1IPprotocol')"
                  v-if="data.sim_mode == 1 || data.sim_mode == 0">
                  <el-select v-model="data.sim1_ipproto" size="mini" class="Form-Input-Width">
                    <el-option label="IPv4" :value="'0'"></el-option>
                    <el-option label="IPv6" :value="'1'"></el-option>
                    <el-option label="IPv4/IPv6" :value="'2'"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('lang.ConfigSetting.SIM1carriermode')"
                  v-if="(deviceSoftwareVer >= 'V2.5.220711') && (data.sim_mode == 1 || data.sim_mode == 0)">
                  <el-select v-model="data.sim1_carrierm" size="mini" class="Form-Input-Width">
                    <el-option :label="$t('lang.wifi.auto')" :value="'0'"></el-option>
                    <el-option :label="$t('lang.ConfigSetting.ChinaMobile')" :value="'1'"></el-option>
                    <el-option :label="$t('lang.ConfigSetting.ChinaUnicom')" :value="'2'"></el-option>
                    <el-option :label="$t('lang.ConfigSetting.ChinaTelecom')" :value="'3'"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM1localIPaddress')"
                  v-if="data.sim_mode == 1 || data.sim_mode == 0">
                  <el-input size="mini" class="Form-Input-Width" v-model="data.sim1_ipaddr"></el-input>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM1PINcode')"
                  v-if="data.sim_mode == 1 || data.sim_mode == 0">
                  <el-input size="mini" class="Form-Input-Width" v-model="data.sim1_pin"></el-input>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM1cardtype')"
                  v-if="data.sim_mode == 1 || data.sim_mode == 0">
                  <el-select v-model="data.sim1_type" size="mini" class="Form-Input-Width">
                    <el-option :label="$t('lang.ConfigSetting.publicnetworkcard')" :value="'0'"></el-option>
                    <el-option :label="$t('lang.ConfigSetting.privatenetworkcard')" :value="'1'"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM1detectionstrategy')"
                  v-if="data.sim_mode == 1 || data.sim_mode == 0">
                  <el-select v-model="data.sim1_policy" size="mini" class="Form-Input-Width">
                    <el-option :label="$t('lang.ConfigSetting.RSSIsignal')" :value="'0'"></el-option>
                    <el-option :label="$t('lang.ConfigSetting.Pingdelay')" :value="'1'"></el-option>
                    <el-option :label="$t('lang.ConfigSetting.mixedstrategy')" :value="'2'"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM1RSSIThreshold')"
                  v-if="data.sim1_policy == 0 || data.sim1_policy == 2">
                  <el-input size="mini" class="Form-Input-Width" v-model="data.sim1_rthreshold"
                    placeholder="0"></el-input>
                  <p style="font-size: 12px;color:#999;">
                    {{ $t('lang.ConfigSetting.scope1') }}
                  </p>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM1LatencyThreshold')" v-if="(data.sim1_policy == 2 || data.sim1_policy == 1) &&
                  (data.sim_mode == 1 || data.sim_mode == 0)
                  ">
                  <el-input size="mini" class="Form-Input-Width" v-model="data.sim1_dthreshold"
                    placeholder="0"></el-input>
                  <p style="font-size: 12px;color:#999;">
                    {{ $t('lang.ConfigSetting.scope2') }}
                  </p>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM1detectionaddress')" v-if="(data.sim1_policy == 1 || data.sim1_policy == 2) &&
                  (data.sim_mode == 1 || data.sim_mode == 0)
                  ">
                  <el-input size="mini" class="Form-Input-Width" v-model="data.sim1_pinghosts"></el-input>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM1detectioncycle')" v-if="(data.sim1_policy == 1 || data.sim1_policy == 2) &&
                  (data.sim_mode == 1 || data.sim_mode == 0)
                  ">
                  <el-select v-model="data.sim1_pinterval" size="mini">
                    <el-option label="60" :value="'60'"></el-option>
                    <el-option label="120" :value="'120'"></el-option>
                    <el-option label="180" :value="'180'"></el-option>
                  </el-select>
                  <p style="font-size: 12px;color:#999;">
                    {{ $t('lang.ConfigSetting.scope3') }}
                  </p>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM1PingCount')" v-if="(data.sim1_policy == 1 || data.sim1_policy == 2) &&
                  (data.sim_mode == 1 || data.sim_mode == 0)
                  ">
                  <el-select v-model="data.sim1_pingcount" size="mini">
                    <el-option label="1" :value="'1'"></el-option>
                    <el-option label="2" :value="'2'"></el-option>
                    <el-option label="3" :value="'3'"></el-option>
                    <el-option label="4" :value="'4'"></el-option>
                    <el-option label="5" :value="'5'"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM2APNaccesspoint')"
                  v-if="data.sim_mode == 2 || data.sim_mode === 0">
                  <select-input :SelectArr="apnList" :SelectValue="data.sim2_apn" @GetSelectValue="GetSelectValueSim1Apn">
                  </select-input>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM2username')"
                  v-if="data.sim_mode == 2 || data.sim_mode === 0">
                  <select-input :SelectArr="SetSeleValueList" :SelectValue="data.sim2_user"
                    @GetSelectValue="GetSelectValueSim1User">
                  </select-input>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM2password')"
                  v-if="data.sim_mode == 2 || data.sim_mode === 0">
                  <select-input :SelectArr="SetSeleValueList" :SelectValue="data.sim2_pwd"
                    @GetSelectValue="GetSelectValueSim1Pwd">
                  </select-input>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM2authenticationtype')"
                  v-if="data.sim_mode == 2 || data.sim_mode === 0">
                  <el-select v-model="data.sim2_authtype" size="mini" class="Form-Input-Width">
                    <el-option label="NONE" :value="'0'"></el-option>
                    <el-option label="PAP" :value="'1'"></el-option>
                    <el-option label="CHAP" :value="'2'"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM2carriermode')"
                  v-if="(deviceSoftwareVer >= 'V2.5.220711') && (data.sim_mode == 2 || data.sim_mode === 0)">
                  <el-select v-model="data.sim2_carrierm" size="mini" class="Form-Input-Width">
                    <el-option :label="$t('lang.wifi.auto')" :value="'0'"></el-option>
                    <el-option :label="$t('lang.ConfigSetting.ChinaMobile')" :value="'1'"></el-option>
                    <el-option :label="$t('lang.ConfigSetting.ChinaUnicom')" :value="'2'"></el-option>
                    <el-option :label="$t('lang.ConfigSetting.ChinaTelecom')" :value="'3'"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM2localIPaddress')"
                  v-if="data.sim_mode == 2 || data.sim_mode === 0">
                  <el-input size="mini" class="Form-Input-Width" v-model="data.sim2_ipaddr"></el-input>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM2PINcode')"
                  v-if="data.sim_mode == 2 || data.sim_mode === 0">
                  <el-input size="mini" class="Form-Input-Width" v-model="data.sim2_pin"></el-input>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM2cardtype')"
                  v-if="data.sim_mode == 2 || data.sim_mode === 0">
                  <el-select v-model="data.sim2_type" size="mini" class="Form-Input-Width">
                    <el-option :label="$t('lang.ConfigSetting.publicnetworkcard')" :value="'0'"></el-option>
                    <el-option :label="$t('lang.ConfigSetting.privatenetworkcard')" :value="'1'"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM2detectionstrategy')"
                  v-if="data.sim_mode == 2 || data.sim_mode === 0">
                  <el-select v-model="data.sim2_policy" size="mini" class="Form-Input-Width">
                    <el-option :label="$t('lang.ConfigSetting.RSSIsignal')" :value="'0'"></el-option>
                    <el-option :label="$t('lang.ConfigSetting.Pingdelay')" :value="'1'"></el-option>
                    <el-option :label="$t('lang.ConfigSetting.mixedstrategy')" :value="'2'"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM2RSSIThreshold')" v-if="data.sim_mode == 2 &&
                  (data.sim2_policy == 0 || data.sim2_policy == 2)
                  ">
                  <el-input size="mini" class="Form-Input-Width" v-model="data.sim2_rthreshold"
                    placeholder="0"></el-input>
                  <p style="font-size: 12px;color:#999;">
                    {{ $t('lang.ConfigSetting.scope1') }}
                  </p>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM2LatencyThreshold')" v-if="(data.sim2_policy == 1 || data.sim2_policy == 2) &&
                  (data.sim_mode == 2 || data.sim_mode === 0)
                  ">
                  <el-input size="mini" class="Form-Input-Width" v-model="data.sim2_dthreshold"
                    placeholder="0"></el-input>
                  <p style="font-size: 12px;color:#999;">
                    {{ $t('lang.ConfigSetting.scope2') }}
                  </p>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM2detectionaddress')" v-if="(data.sim2_policy == 1 || data.sim2_policy == 2) &&
                  (data.sim_mode == 2 || data.sim_mode === 0)
                  ">
                  <el-input size="mini" class="Form-Input-Width" v-model="data.sim2_pinghosts"></el-input>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM2detectioncycle')" v-if="(data.sim2_policy == 1 || data.sim2_policy == 2) &&
                  (data.sim_mode == 2 || data.sim_mode === 0)
                  ">
                  <el-select v-model="data.sim2_pinterval" size="mini">
                    <el-option label="60" :value="'60'"></el-option>
                    <el-option label="120" :value="'120'"></el-option>
                    <el-option label="180" :value="'180'"></el-option>
                  </el-select>
                  <p style="font-size: 12px;color:#999;">
                    {{ $t('lang.ConfigSetting.scope3') }}
                  </p>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIM2PingCount')" v-if="(data.sim2_policy == 1 || data.sim2_policy == 2) &&
                  (data.sim_mode == 2 || data.sim_mode === 0)
                  ">
                  <el-select v-model="data.sim2_pingcount" size="mini">
                    <el-option label="1" :value="'1'"></el-option>
                    <el-option label="2" :value="'2'"></el-option>
                    <el-option label="3" :value="'3'"></el-option>
                    <el-option label="4" :value="'4'"></el-option>
                    <el-option label="5" :value="'5'"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.Restartafternetworkdisconnection')">
                  <el-select v-model="data.rebootsys" size="mini" class="Form-Input-Width">
                    <el-option :label="$t('lang.ConfigSetting.Disable')" :value="'0'"></el-option>
                    <el-option :label="$t('lang.ConfigSetting.Enable')" :value="'1'"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.AlibabaCloudEagleCard')">
                  <el-select v-model="data.smartenable" size="mini" class="Form-Input-Width">
                    <el-option :label="$t('lang.ConfigSetting.Disable')" :value="'0'"></el-option>
                    <el-option :label="$t('lang.ConfigSetting.Enable')" :value="'1'"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.defaultcarrier')" v-if="deviceSoftwareVer <= 'V2.5.220711'">
                  <el-select v-model="data.smartcard" size="mini" class="Form-Input-Width">
                    <el-option :label="$t('lang.ConfigSetting.ChinaMobile')" :value="'1'"></el-option>
                    <el-option :label="$t('lang.ConfigSetting.ChinaUnicom')" :value="'2'"></el-option>
                    <el-option :label="$t('lang.ConfigSetting.ChinaTelecom')" :value="'3'"></el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item label="APN：" prop="name">
                  <select-input
                    :SelectArr="SetSeleValueList"
                    :SelectValue="data.apn==''?'0':data.apn"
                    @GetSelectValue="GetSelectValueApn">
                  </select-input>
                </el-form-item>
                <el-form-item :label="`${$t('lang.ConfigSetting.PAPCHAPusername')}：`" prop="name">
                  <select-input
                    :SelectArr="SetSeleValueList"
                    :SelectValue="data.username"
                    @GetSelectValue="GetSelectValueUsername">
                  </select-input>
                </el-form-item>
                <el-form-item :label="`${$t('lang.ConfigSetting.PAPCHAPpassword')}：`" prop="name">
                  <select-input
                    :SelectArr="SetSeleValueList"
                    :SelectValue="data.password"
                    @GetSelectValue="GetSelectValuePassword">
                  </select-input>
                </el-form-item> -->
                <!-- <el-form-item :label="`${$t('lang.ConfigSetting.AuthenticationType')}：`" prop="name">
                  <el-select
                    :placeholder="$t('lang.ConfigSetting.pleaseChoose')"
                    v-model="data.pppd_options"
                    size="mini"
                    class="Form-Input-Width">
                    <el-option
                      v-for="item in AuthenticationList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="`${$t('lang.ConfigSetting.ICMPCheck')}：`" prop="name">
                  <el-select
                    :placeholder="$t('lang.ConfigSetting.pleaseChoose')"
                    v-model="data.icmpenable"
                    size="mini"
                    class="Form-Input-Width">
                    <el-option
                      v-for="item in IcmpList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item> -->
              </el-form>
            </div>
          </div>
          <el-button type="danger" size="mini" @click="updateConfig" class="Config-Buttom">
            {{ $t("lang.ConfigSetting.SaveApply") }}
          </el-button>
        </div>
        <!-- 协议为ppp显示 -->
        <div class="box-card" v-if="data.proto === '3g'">
          <div class="text item">
            <div class="Table-Con">
              <el-form ref="ruleForm" label-width="200px" class="demo-ruleForm">
                <el-form-item :label="`${$t('lang.ConfigSetting.Protocol')}：`" prop="name">
                  <el-select :placeholder="$t('lang.ConfigSetting.pleaseChoose')" v-model="data.proto" size="mini"
                    class="Form-Input-Width">
                    <el-option v-for="item in protocol" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="PIN：" prop="name">
                  <el-input size="mini" class="Form-Input-Width" v-model="data.pincode"></el-input>
                </el-form-item>
                <el-form-item :label="`${$t('lang.ConfigSetting.NetworkType')}：`" prop="name">
                  <el-select :placeholder="$t('lang.ConfigSetting.pleaseChoose')" v-model="data.nettype" size="mini"
                    class="Form-Input-Width">
                    <el-option v-for="item in InternetList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.SIMmode')">
                  <el-select v-model="data.sim_mode" size="mini" class="Form-Input-Width">
                    <el-option label="SIM1" :value="'1'"></el-option>
                    <el-option label="SIM2" v-if="data.sim_mode == 0 || data.sim_mode == 2" :value="'2'"></el-option>
                    <el-option :label="$t('lang.ConfigSetting.Dualcardbackup')"
                      v-if="data.sim_mode == 0 || data.sim_mode == 2" :value="'0'"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="APN：" prop="name">
                  <select-input :SelectArr="SetSeleValueList" :SelectValue="data.apn == '' ? '0' : data.apn"
                    @GetSelectValue="GetSelectValueApn">
                  </select-input>
                </el-form-item>
                <el-form-item :label="`${$t('lang.ConfigSetting.PAPCHAPusername')}：`" prop="name">
                  <select-input :SelectArr="SetSeleValueList" :SelectValue="data.username"
                    @GetSelectValue="GetSelectValueUsername">
                  </select-input>
                </el-form-item>
                <el-form-item :label="`${$t('lang.ConfigSetting.PAPCHAPpassword')}：`" prop="name">
                  <select-input :SelectArr="SetSeleValueList" :SelectValue="data.password"
                    @GetSelectValue="GetSelectValuePassword">
                  </select-input>
                </el-form-item>
                <el-form-item :label="`${$t('lang.ConfigSetting.ServiceType')}：`" prop="name">
                  <select-input :SelectArr="ServiceList" :SelectValue="data.service == '' ? 'umts' : data.service"
                    @GetSelectValue="GetSelectValueService">
                  </select-input>
                </el-form-item>
                <el-form-item :label="`${$t('lang.ConfigSetting.Dialnumber')}：`" prop="name">
                  <select-input :SelectArr="DialList" :SelectValue="data.dialnumber == '' ? '*99#' : data.dialnumber
                    " @GetSelectValue="GetSelectValueDialnumber">
                  </select-input>
                </el-form-item>
                <el-form-item :label="`${$t('lang.ConfigSetting.AuthenticationType')}：`" prop="name">
                  <el-select :placeholder="$t('lang.ConfigSetting.pleaseChoose')" v-model="data.pppd_options" size="mini"
                    class="Form-Input-Width">
                    <el-option v-for="item in CertificationList" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="`${$t('lang.ConfigSetting.LocalIPAddress')}：`" prop="name">
                  <el-input size="mini" class="Form-Input-Width" v-model="data.local_IP_address"
                    @change="ErrorIp(data.local_IP_address, 'local_IP_address')">
                  </el-input>
                  <p class="error-mess" v-if="error.local_IP_address">
                    {{ $t("lang.ConfigSetting.Pleasecheck") }}
                  </p>
                </el-form-item>
                <el-form-item :label="`${$t('lang.ConfigSetting.ICMPCheck')}：`" prop="name">
                  <el-select :placeholder="$t('lang.ConfigSetting.pleaseChoose')" v-model="data.icmpenable" size="mini"
                    class="Form-Input-Width">
                    <el-option v-for="item in IcmpList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <el-button type="danger" size="mini" @click="updateConfig" class="Config-Buttom">{{
            $t("lang.ConfigSetting.SaveApply") }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SelectInput from "../../../SelectInput/index";
import networkInfo from "../../../networkInfo/index";
import { cloneDeep, isEqual } from "lodash";
export default {
  props: ["data", "loading", "networkInfo", "WatchData", "deviceSoftwareVer"],
  data() {
    return {
      protocol: [
        { label: this.$t("lang.ConfigSetting.DHCPclient"), value: "dhcp" },
        { label: "PPP", value: "3g" },
      ],
      checked: true,
      InternetList: [
        { label: this.$t("lang.ConfigSetting.Automatic"), value: "0" },
        { label: "5G", value: "4" },
        { label: "4G", value: "1" },
        { label: "3G", value: "2" },
        { label: "2G", value: "3" },
      ],
      SetSeleValueList: [
        { label: this.$t("lang.ConfigSetting.Automatic"), value: "0" },
        { label: this.$t("lang.ConfigSetting.custom"), value: "自定义" },
      ],
      apnList: [
        { label: this.$t("lang.ConfigSetting.Automatic"), value: "" },
        { label: this.$t("lang.ConfigSetting.custom"), value: "自定义" },
      ],
      //认证类型
      AuthenticationList: [
        { label: "NONE", value: "0" },
        { label: "PAP", value: "1" },
        { label: "CHAP", value: "2" },
      ],
      //ppp认证类型
      CertificationList: [
        { label: this.$t("lang.ConfigSetting.Automatic"), value: "0" },
        {
          label: "PAP",
          value:
            "require-pap refuse-eap refuse-chap refuse-mschap refuse-mschap-v2",
        },
        {
          label: "CHAP",
          value:
            "require-chap refuse-eap refuse-pap refuse-mschap refuse-mschap-v2",
        },
        {
          label: "MS-CHAP",
          value:
            "require-mschap refuse-eap refuse-chap refuse-pap refuse-mschap-v2",
        },
        {
          label: "MS-CHAPv2",
          value:
            "require-mschap-v2 refuse-eap refuse-chap refuse-mschap refuse-pap",
        },
      ],
      //ICMP检测
      IcmpList: [
        { label: this.$t("lang.ConfigSetting.Enable"), value: "1" },
        { label: this.$t("lang.ConfigSetting.Disable"), value: "0" },
      ],
      //服务器类型
      ServiceList: [
        { label: "UMTS/TDS-CDMA/GPRS", value: "umts" },
        { label: "CDMA/EV-DO", value: "evdo" },
        { label: this.$t("lang.ConfigSetting.custom"), value: this.$t("lang.ConfigSetting.custom") },
      ],
      //拨号
      DialList: [
        { label: "*99#", value: "*99#" },
        { label: "#777", value: "#777" },
        { label: "*98*1#", value: "*98*1#" },
        { label: "*99***1#", value: "*99***1#" },
        { label: this.$t("lang.ConfigSetting.custom"), value: this.$t("lang.ConfigSetting.custom") },
      ],
      error: {
        hostname: false,
        local_IP_address: false,
      },
      // 密码自定义时，输入框类型
      inputType: "password",
      sim1SelectList: [],
    };
  },
  methods: {
    //接收apn改变的值
    GetSelectValueApn(props) {
      this.data.apn = props;
    },
    //接收sim1_user改变的值
    GetSelectValueSim1User(props) {
      this.data.sim1_user = props;
    },
    //接收sim1_pwd改变的值
    GetSelectValueSim1Pwd(props) {
      this.data.sim1_pwd = props;
    },
    //接收sim1_apn改变的值
    GetSelectValueSim1Apn(props) {
      this.data.sim1_apn = props;
    },
    //接收usernmae改变的值
    GetSelectValueUsername(props) {
      this.data.username = props;
    },
    //接收password改变的值
    GetSelectValuePassword(props) {
      console.log(props);
      this.data.password = props;
    },
    //接收service改变的值
    GetSelectValueService(props) {
      this.data.service = props;
    },
    //接收dialnumber改变的值
    GetSelectValueDialnumber(props) {
      this.data.dialnumber = props;
    },
    //不为中文验证
    ErrorHost(props, key) {
      let test = /^[a-z0-9]+$/i;
      let retu = false;
      if (!test.test(props)) {
        this.error[key] = true;
        retu = true;
      }
      if (!props) {
        this.error[key] = false;
        retu = false;
      }
      if (!retu) {
        this.error[key] = false;
      }
    },
    //ip验证
    ErrorIp(props, key) {
      let test = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      let retu = false;
      if (!test.test(props)) {
        this.error[key] = true;
        retu = true;
      }
      if (!props) {
        this.error[key] = false;
        retu = false;
      }
      if (!retu) {
        this.error[key] = false;
      }
    },
    //提交修改
    updateConfig() {
      if (this.data.proto === "dhcp") {
        if (this.error.hostname) {
          return;
        }
      } else if (this.data.proto === "3g") {
        if (this.error.local_IP_address) {
          return;
        }
      }
      let data = {};
      // //循环筛选不为空的值(不为空则未修改无需上传)
      for (let key in this.data) {
        if (this.data[key] !== "") {
          data[key] = this.data[key];
        }
      }
      if (Object.keys(data).length > 0) {
        if (!isEqual(this.data, this.WatchData)) {
          if (this.data.pppd_options == "0") {
            data.pppd_options = "";
          }
          this.$emit("updateWan", data);
        } else {
          this.$message({
            showClose: true,
            message: this.$t("lang.ConfigSetting.Nochangesmade"),
            type: "warning",
          });
          return;
        }
      } else {
        this.$message({
          showClose: true,
          message: this.$t("lang.ConfigSetting.Nochangesmade"),
          type: "warning",
        });
        return;
      }
    },
    sim1apnChange(e) {
      if (this.data[e] == "") {
      } else {
        this.sim1SelectList.push(e);
        this.data[e] ? this.data[e] : "";
      }
    },
    sim1apnBlur(e) {
      this.sim1SelectList = this.sim1SelectList.filter((v) => v != e);
      this.data[e] ? this.data[e] : "";
    },
  },
  components: {
    SelectInput,
    networkInfo,
  },
  directives: {
    focus: {
      // 指令的定义
      inserted: function (el) {
        el.children[0].focus();
        //使用官方示例 el.focus(); 不能自动获取焦点，是因为 insert是一个钩子函数，只有父节点存在，在插入父节点时调用，我这里并没有插入所以没有调用。
      },
    },
  },
};
</script>
<style src="../../../common.css" scoped></style>
